export default __webpack_public_path__ + "static/media/tag-startupchile.2a60ea86.png";